export default interface ReferralStoreSettingDTO {
  referralId?: number;
  payInFee?: string;
  payInFeeType?: number;
  payOutFee?: string;
  payOutFeeType?: number;
}

export const REFERRAL_SLOTS = [1, 2, 3, 4, 5];

export const referralSlotKey = (slot: number): string => `referral${slot}`;
